import axios from 'axios';
import auth from '@/api/v1/auth/authService';

export default {
  getUser(id, succ) {
    axios.get(`/users/${id}`).then((response) => {
      succ(response.data);
    });
  },
  getAllUsers(succ) {
    axios.get('/users').then((response) => {
      succ(response.data);
    });
  },
  getProfessions(succ) {
    axios.get('/professions').then((response) => {
      succ(response.data);
    });
  },
  updateUser(data) {
    return axios.patch('/users/profile', data);
  },
  myProfile(succ) {
    const getProfile = () => {
      axios.get('/users/profile').then((response) => {
        if (response.data.birthday) {
          const birthday = new Date(response.data.birthday);
          response.data.birthday = `${birthday.getFullYear()}-${birthday.getMonth() + 1}-${birthday.getDate()}`;
        }
        succ(response.data);
      });
    };

    if (auth.user.authenticated) getProfile();
  },
  getProjects(succ) {
    axios.get('/users/projects').then((response) => {
      succ(response.data);
    });
  },
  getOrganization(succ) {
    axios.get('/users/organization').then((response) => {
      succ(response.data);
    });
  },
  search(query, succ, page) {
    axios.get('/users/search', { params: { search: query, page } }).then((response) => {
      succ(response.data);
    });
  },
  sendMessage(message) {
    message.subject = message.subject || 'Domore - contact';
    return axios.post('/messages/send', message);
  },
  subscribeForNewsletter(subscription) {
    return axios.post('/newsletter/subscribe', { subscription });
  },
  createUserKycDocument(documents) {
    return axios.post('kyc_authorizations', { kyc_document: { pages: documents } });
  },
  submitUserKycDocument() {
    return axios.patch('kyc_authorizations/submit');
  },
  checkUserKycDocument() {
    return axios.get('kyc_authorizations');
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/user.js